import { SvgIcon } from './svg-icon';
import { SvgIconProps } from './svg-icon.types';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    stroke: 'none',
    fill: 'currentColor',
};

export const ErrorIcon = (componentProps: SvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path d="M8 12C8.23 12 8.42 11.92 8.57 11.77C8.72 11.62 8.8 11.43 8.8 11.2C8.8 10.97 8.72 10.78 8.57 10.63C8.42 10.48 8.23 10.4 8 10.4C7.77 10.4
   7.58 10.48 7.43 10.63C7.28 10.78 7.2 10.97 7.2 11.2C7.2 11.43 7.28 11.62 7.43 11.77C7.58 11.92 7.77 12 8 12ZM8 8.8C8.23 8.8 8.42 8.72 8.57
  8.57C8.72 8.42 8.8 8.23 8.8 8V4.8C8.8 4.57 8.72 4.38 8.57 4.23C8.42 4.08 8.23 4 8 4C7.77 4 7.58 4.08 7.43 4.23C7.28 4.38 7.2 4.57 7.2 4.8V8C7.2
  8.23 7.28 8.42 7.43 8.57C7.58 8.72 7.77 8.8 8 8.8ZM8 16C6.9 16 5.85 15.79 4.88 15.37C3.9 14.95 3.06 14.38 2.34 13.66C1.62 12.94 1.05 12.1 0.63
  11.12C0.21 10.15 0 9.1 0 8C0 6.9 0.21 5.85 0.63 4.88C1.05 3.9 1.62 3.06 2.34 2.34C3.06 1.62 3.9 1.05 4.88 0.63C5.85 0.21 6.9 0 8 0C9.1 0 10.15
  0.21 11.12 0.63C12.1 1.05 12.94 1.62 13.66 2.34C14.38 3.06 14.95 3.9 15.37 4.88C15.79 5.85 16 6.9 16 8C16 9.1 15.79 10.15 15.37 11.12C14.95 12.1
   14.38 12.94 13.66 13.66C12.94 14.38 12.1 14.95 11.12 15.37C10.15 15.79 9.1 16 8 16ZM8 14.4C9.78 14.4 11.29 13.78 12.54 12.54C13.78 11.29 14.4
  9.78 14.4 8C14.4 6.22 13.78 4.71 12.54 3.46C11.29 2.22 9.78 1.6 8 1.6C6.22 1.6 4.71 2.22 3.46 3.46C2.22 4.71 1.6 6.22 1.6 8C1.6 9.78 2.22 11.29
  3.46 12.54C4.71 13.78 6.22 14.4 8 14.4Z" fill="currentColor" />
        </SvgIcon>

    );
};


